var _firstInsert = false;

export let setFirstInsert = (val) => (_firstInsert = val);
export let getFirstInsert = () => _firstInsert;
